// "use client";
//
// import { Input } from "@/components/ui/input";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { Card } from "@/components/ui/card";
// import { useFormContext } from "react-hook-form";
// import {
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "@/components/ui/form";
// import { CalendarIcon } from "lucide-react";
// import { format } from "date-fns";
// import { Calendar } from "@/components/ui/calendar";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover";
// import { cn, formatDate } from "@/lib/utils";
// import { Button } from "@/components/ui/button";
// import { nigerianBreeds } from "@/utils/items.ts";
//
// export function ParentalInfoForm() {
//   const { control } = useFormContext();
//
//   // For dam birth date
//   // const [damBirthDate, setDamBirthDate] = useState<Date | undefined>(
//   //   watch("damBirthDate") ? new Date(watch("damBirthDate")) : undefined,
//   // );
//   //
//   // // For sire birth date
//   // const [sireBirthDate, setSireBirthDate] = useState<Date | undefined>(
//   //   watch("sireBirthDate") ? new Date(watch("sireBirthDate")) : undefined,
//   // );
//   //
//   // const handleDamDateSelect = (date: Date | undefined) => {
//   //   setDamBirthDate(date);
//   //   if (date) {
//   //     setValue("damBirthDate", date.toISOString());
//   //   }
//   // };
//   //
//   // const handleSireDateSelect = (date: Date | undefined) => {
//   //   setSireBirthDate(date);
//   //   if (date) {
//   //     setValue("sireBirthDate", date.toISOString());
//   //   }
//   // };
//
//   return (
//     <div className="space-y-6">
//       <h2 className="text-2xl font-bold text-center mb-6">
//         Parental Information
//       </h2>
//
//       <div className="space-y-6">
//         <div className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg">
//           <h3 className="text-lg font-semibold mb-4">
//             Dam (Mother) Information
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <FormField
//               control={control}
//               name="damName"
//               render={({ field }) => (
//                 <FormItem>
//                   <FormLabel className={"text-[#008c8fff]"}>Dam Name</FormLabel>
//                   <FormControl>
//                     <Input placeholder="Enter dam name" {...field} />
//                   </FormControl>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />
//
//             <FormField
//               control={control}
//               name="damDGR"
//               render={({ field }) => (
//                 <FormItem>
//                   <FormLabel className={"text-[#008c8fff]"}>Dam DGR</FormLabel>
//                   <FormControl>
//                     <Input placeholder="Enter dam DGR" {...field} />
//                   </FormControl>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />
//
//             {/* <FormField */}
//             {/*   control={control} */}
//             {/*   name="damBirthDate" */}
//             {/*   render={({}) => ( */}
//             {/*     <FormItem className="flex flex-col"> */}
//             {/*       <FormLabel className={"text-[#008c8fff]"}>Dam Birth
// Date</FormLabel> */} {/*       <Popover> */} {/*         <PopoverTrigger asChild>
// */} {/*           <FormControl> */} {/*             <Button */} {/*
// variant="outline" */} {/*               className={cn( */} {/*
// "w-full pl-3 text-left font-normal", */} {/*                 !damBirthDate &&
// "text-muted-foreground", */} {/*               )} */} {/*             > */} {/*
//             <CalendarIcon className="mr-2 h-4 w-4" /> */} {/*
// {damBirthDate ? ( */} {/*                 format(damBirthDate, "PPP") */} {/*
//           ) : ( */} {/*                 <span>Select date</span> */} {/*
//      )} */} {/*             </Button> */} {/*           </FormControl> */} {/*
//      </PopoverTrigger> */} {/*         <PopoverContent */} {/*           className="w-auto p-0" */} {/*           align="start" */} {/*           side="bottom" */} {/*         > */} {/*           <Calendar */} {/*             mode="single" */} {/*             selected={damBirthDate} */} {/*             onSelect={handleDamDateSelect} */} {/*             initialFocus */} {/*             disabled={(date) => date > new Date()} */} {/*           /> */} {/*         </PopoverContent> */} {/*       </Popover> */} {/*       <FormMessage /> */} {/*     </FormItem> */} {/*   )} */} {/* /> */}  <FormField control={control} name="damBirthDate" render={({ field }) => ( <FormItem className="flex flex-col"> <FormLabel className={"text-[#008c8fff]"}>Dam Date of birth</FormLabel> <Popover> <PopoverTrigger asChild> <FormControl> <Button variant={"outline"} className={cn( "w-[240px] pl-3 text-left font-normal", !field.value && "text-muted-foreground", )} > {field.value ? ( format(field.value, "PPP") ) : ( <span>Pick a date</span> )} <CalendarIcon className="ml-auto h-4 w-4 opacity-50" /> </Button> </FormControl> </PopoverTrigger> <PopoverContent className="w-auto p-0" align="start"> <Calendar mode="single" selected={field.value} onSelect={(date) => field.onChange(formatDate(date))} // onSelect={ field.onChange } disabled={(date: any) => date > new Date() || date < new Date("1900-01-01") } captionLayout="dropdown" /> </PopoverContent> </Popover> <FormMessage /> </FormItem> )} />  <FormField control={control} name="damBreed" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Dam Breed</FormLabel> <Select onValueChange={field.onChange} defaultValue={field.value} > <FormControl> <SelectTrigger> <SelectValue placeholder="Select dam breed" /> </SelectTrigger> </FormControl> <SelectContent position="popper" className="max-h-[300px] overflow-y-auto z-50 shadow-lg bg-white " > {nigerianBreeds.map((option) => ( <SelectItem className={"overflow-y-auto z-50 background-white"} key={option.breed} value={option.breed} > {option.label} </SelectItem> ))} </SelectContent> </Select> <FormMessage /> </FormItem> )} /> </div> </div>  <div className="bg-slate-100 dark:bg-slate-800 p-4 rounded-lg"> <h3 className="text-lg font-semibold mb-4"> Sire (Father) Information </h3> <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> <FormField control={control} name="sireName" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire Name</FormLabel> <FormControl> <Input placeholder="Enter sire name" {...field} /> </FormControl> <FormMessage /> </FormItem> )} />  <FormField control={control} name="sireDGR" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire DGR</FormLabel> <FormControl> <Input placeholder="Enter sire DGR" {...field} /> </FormControl> <FormMessage /> </FormItem> )} />  {/* <FormField */} {/*   control={control} */} {/* name="sireBirthDate" */} {/*   render={({}) => ( */} {/*     <FormItem className="flex flex-col"> */} {/*       <FormLabel className={"text-[#008c8fff]"}>Sire Birth Date</FormLabel> */} {/*       <Popover> */} {/*         <PopoverTrigger asChild> */} {/* <FormControl> */} {/*             <Button */} {/* variant="outline" */} {/*               className={cn( */} {/* "w-full pl-3 text-left font-normal", */} {/*                 !sireBirthDate && "text-muted-foreground", */} {/*               )} */} {/*             > */} {/* <CalendarIcon className="mr-2 h-4 w-4" /> */} {/* {sireBirthDate ? ( */} {/*                 format(sireBirthDate, "PPP") */} {/* ) : ( */} {/*                 <span>Select date</span> */} {/* )} */} {/*             </Button> */} {/*           </FormControl> */} {/* </PopoverTrigger> */} {/*         <PopoverContent */} {/* className="w-auto p-0" */} {/*           align="start" */} {/* side="bottom" */} {/*         > */} {/*           <Calendar */} {/* mode="single" */} {/*             selected={sireBirthDate} */} {/* onSelect={handleSireDateSelect} */} {/*             initialFocus */} {/* disabled={(date) => date > new Date()} */} {/*           /> */} {/* </PopoverContent> */} {/*       </Popover> */} {/*       <FormMessage /> */} {/* </FormItem> */} {/*   )} */} {/* /> */}  <FormField control={control} name="sireBirthDate" render={({ field }) => ( <FormItem className="flex flex-col"> <FormLabel className={"text-[#008c8fff]"}>Sire Date of birth</FormLabel> <Popover> <PopoverTrigger asChild> <FormControl> <Button variant={"outline"} className={cn( "w-[240px] pl-3 text-left font-normal", !field.value && "text-muted-foreground", )} > {field.value ? ( format(field.value, "PPP") ) : ( <span>Pick a date</span> )} <CalendarIcon className="ml-auto h-4 w-4 opacity-50" /> </Button> </FormControl> </PopoverTrigger> <PopoverContent className="w-auto p-0" align="start"> <Calendar mode="single" selected={field.value} onSelect={(date) => field.onChange(formatDate(date))} // onSelect={ field.onChange } disabled={(date: any) => date > new Date() || date < new Date("1900-01-01") } captionLayout="dropdown" /> </PopoverContent> </Popover> <FormMessage /> </FormItem> )} />  <FormField control={control} name="sireBreed" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire Breed</FormLabel> <Select onValueChange={field.onChange} defaultValue={field.value} > <FormControl> <SelectTrigger> <SelectValue placeholder="Select sire breed" /> </SelectTrigger> </FormControl> <SelectContent position="popper" className="max-h-[300px] overflow-y-auto z-50 shadow-lg bg-white " > {nigerianBreeds.map((option) => ( <SelectItem className={"overflow-y-auto z-50 background-white"} key={option.breed} value={option.breed} > {option.label} </SelectItem> ))} </SelectContent> </Select> <FormMessage /> </FormItem> )} /> </div> </div> </div> <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700"> <p className="text-sm text-slate-600 dark:text-slate-400"> Parental information is crucial for tracking lineage and genetic traits. Complete and accurate information helps with breeding programs and genetic improvement. </p> </Card> </div> ); }

// "use client";
//
// import { Input } from "@/components/ui/input";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { Card } from "@/components/ui/card";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
// import { useFormContext } from "react-hook-form";
// import {
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "@/components/ui/form";
// import { CalendarIcon, Heart, Users2 } from "lucide-react";
// import { format } from "date-fns";
// import { Calendar } from "@/components/ui/calendar";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover";
// import { cn } from "@/lib/utils";
//
// import { useState } from "react";
// import { Button } from "@/components/ui/button";
// import { ImageUpload } from "@/components/ui/image-upload";
// import { nigerianBreeds } from "@/utils/items.ts";
//
// interface ParentalInfoFormProps {
//   damImageFile: string | File | undefined;
//   setDamImageFile: (value: string | File | undefined) => void;
//   sireImageFile: string | File | undefined;
//   setSireImageFile: (value: string | File | undefined) => void;
// }
//
// export function ParentalInfoForm({
//   damImageFile,
//   setDamImageFile,
//   sireImageFile,
//   setSireImageFile,
// }: ParentalInfoFormProps) {
//   const { control, setValue, watch } = useFormContext();
//
//   const [damBirthDate, setDamBirthDate] = useState<Date | undefined>(
//     watch("damBirthDate") ? new Date(watch("damBirthDate")) : undefined,
//   );
//
//   // For sire birth date
//   const [sireBirthDate, setSireBirthDate] = useState<Date | undefined>(
//     watch("sireBirthDate") ? new Date(watch("sireBirthDate")) : undefined,
//   );
//
//   const handleDamDateSelect = (date: Date | undefined) => {
//     setDamBirthDate(date);
//     if (date) {
//       setValue("damBirthDate", date.toISOString());
//     }
//   };
//
//   const handleSireDateSelect = (date: Date | undefined) => {
//     setSireBirthDate(date);
//     if (date) {
//       setValue("sireBirthDate", date.toISOString());
//     }
//   };
//
//   return (
//     <div className="space-y-6">
//       <div className="text-center space-y-2">
//         <div className="flex items-center justify-center gap-2">
//           <Heart className="h-6 w-6 text-pink-600" />
//           <h2 className="text-2xl font-bold">Parental Information</h2>
//         </div>
//         <p className="text-muted-foreground">
//           Record detailed information about the animal's parents
//         </p>
//       </div>
//
//       <Tabs defaultValue="dam" className="w-full">
//         <TabsList className="grid w-full grid-cols-2">
//           <TabsTrigger value="dam" className="flex items-center gap-2">
//             <Users2 className="h-4 w-4" />
//             Dam (Mother)
//           </TabsTrigger>
//           <TabsTrigger value="sire" className="flex items-center gap-2">
//             <Users2 className="h-4 w-4" />
//             Sire (Father)
//           </TabsTrigger>
//         </TabsList>
//
//         <TabsContent value="dam" className="space-y-6 mt-6">
//           <div className="bg-pink-50 dark:bg-pink-950/20 p-6 rounded-lg border
// border-pink-200 dark:border-pink-800"> <div className="flex items-center gap-2
// mb-6"> <Heart className="h-5 w-5 text-pink-600" /> <h3 className="text-lg
// font-semibold text-pink-900 dark:text-pink-100"> Dam (Mother) Information </h3>
// </div>  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6"> <div
// className="space-y-6"> <FormField control={control} name="damName" render={({
// field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Dam
// Name</FormLabel> <FormControl> <Input placeholder="Enter dam name" {...field} />
// </FormControl> <FormMessage /> </FormItem> )} />  <FormField control={control}
// name="damDGR" render={({ field }) => ( <FormItem> <FormLabel
// className={"text-[#008c8fff]"}>Dam DGR</FormLabel> <FormControl> <Input
// placeholder="Enter dam DGR" {...field} /> </FormControl> <FormMessage />
// </FormItem> )} />  <FormField control={control} name="damBirthDate" render={({})
// => ( <FormItem className="flex flex-col"> <FormLabel
// className={"text-[#008c8fff]"}>Dam Birth Date</FormLabel> <Popover>
// <PopoverTrigger asChild> <FormControl> <Button variant="outline" className={cn(
// "w-full pl-3 text-left font-normal", !damBirthDate && "text-muted-foreground", )} > <CalendarIcon className="mr-2 h-4 w-4" /> {damBirthDate ? ( format(damBirthDate, "PPP") ) : ( <span>Select date</span> )} </Button> </FormControl> </PopoverTrigger> <PopoverContent className="w-auto p-0" align="start" side="bottom" > <Calendar mode="single" selected={damBirthDate} onSelect={handleDamDateSelect} initialFocus disabled={(date) => date > new Date()} /> </PopoverContent> </Popover> <FormMessage /> </FormItem> )} /> <FormField control={control} name="damBreed" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Dam Breed</FormLabel> <Select onValueChange={field.onChange} defaultValue={field.value} > <FormControl> <SelectTrigger> <SelectValue placeholder="Select dam breed" /> </SelectTrigger> </FormControl> <SelectContent position="popper" className="max-h-[300px] overflow-y-auto" > {nigerianBreeds.map((option) => ( <SelectItem key={option.breed} value={option.breed}> {option.label} </SelectItem> ))} </SelectContent> </Select> <FormMessage /> </FormItem> )} /> </div>  <div> <FormField control={control} name="damImage" render={({}) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Dam Image</FormLabel> <FormControl> <ImageUpload value={damImageFile} onChange={setDamImageFile} label="Upload Dam Image" description="Add a photo of the dam" /> </FormControl> <FormMessage /> </FormItem> )} /> </div> </div> </div> </TabsContent> <TabsContent value="sire" className="space-y-6 mt-6"> <div className="bg-blue-50 dark:bg-blue-950/20 p-6 rounded-lg border border-blue-200 dark:border-blue-800"> <div className="flex items-center gap-2 mb-6"> <Users2 className="h-5 w-5 text-blue-600" /> <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-100"> Sire (Father) Information </h3> </div>  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6"> <div className="space-y-6"> <FormField control={control} name="sireName" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire Name</FormLabel> <FormControl> <Input placeholder="Enter sire name" {...field} /> </FormControl> <FormMessage /> </FormItem> )} />  <FormField control={control} name="sireDGR" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire DGR</FormLabel> <FormControl> <Input placeholder="Enter sire DGR" {...field} /> </FormControl> <FormMessage /> </FormItem> )} />  <FormField control={control} name="sireBirthDate" render={({}) => ( <FormItem className="flex flex-col"> <FormLabel className={"text-[#008c8fff]"}>Sire Birth Date</FormLabel> <Popover> <PopoverTrigger asChild> <FormControl> <Button variant="outline" className={cn( "w-full pl-3 text-left font-normal", !sireBirthDate && "text-muted-foreground", )} > <CalendarIcon className="mr-2 h-4 w-4" /> {sireBirthDate ? ( format(sireBirthDate, "PPP") ) : ( <span>Select date</span> )} </Button> </FormControl> </PopoverTrigger> <PopoverContent className="w-auto p-0" align="start" side="bottom" > <Calendar mode="single" selected={sireBirthDate} onSelect={handleSireDateSelect} initialFocus disabled={(date) => date > new Date()} /> </PopoverContent> </Popover> <FormMessage /> </FormItem> )} /> <FormField control={control} name="sireBreed" render={({ field }) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire Breed</FormLabel> <Select onValueChange={field.onChange} defaultValue={field.value} > <FormControl> <SelectTrigger> <SelectValue placeholder="Select sire breed" /> </SelectTrigger> </FormControl> <SelectContent position="popper" className="max-h-[300px] overflow-y-auto" > {nigerianBreeds.map((option) => ( <SelectItem key={option.breed} value={option.breed}> {option.label} </SelectItem> ))} </SelectContent> </Select> <FormMessage /> </FormItem> )} /> </div>  <div> <FormField control={control} name="sireImage" render={({}) => ( <FormItem> <FormLabel className={"text-[#008c8fff]"}>Sire Image</FormLabel> <FormControl> <ImageUpload value={sireImageFile} onChange={setSireImageFile} label="Upload Sire Image" description="Add a photo of the sire" /> </FormControl> <FormMessage /> </FormItem> )} /> </div> </div> </div> </TabsContent> </Tabs> <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700"> <div className="flex items-start gap-3"> <Heart className="h-5 w-5 text-pink-600 mt-0.5 flex-shrink-0" /> <div className="space-y-2"> <h4 className="font-medium text-slate-900 dark:text-slate-100"> Parental Information Guidelines </h4> <p className="text-sm text-slate-600 dark:text-slate-400"> Parental information is crucial for tracking lineage and genetic traits. Complete and accurate information helps with breeding programs and genetic improvement. Images provide visual documentation for identification and record-keeping purposes. Use the tabs above to switch between dam and sire information entry. </p> </div> </div> </Card> </div> ); }

"use client";

import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { CalendarIcon, Heart, Users2 } from "lucide-react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn, formatDate } from "@/lib/utils";
import { ElementType, useState } from "react";
import { Button } from "@/components/ui/button";
import { ImageUpload } from "@/components/ui/image-upload";
import { nigerianBreeds } from "@/utils/items.ts";
import { Card } from "@heroui/card";

// Define the props for the component
interface ParentalInfoFormProps {
  damImageFile: string | File | undefined;
  setDamImageFile: (value: string | File | undefined) => void;
  sireImageFile: string | File | undefined;
  setSireImageFile: (value: string | File | undefined) => void;
}

export function ParentalInfoForm({
  damImageFile,
  setDamImageFile,
  sireImageFile,
  setSireImageFile,
}: ParentalInfoFormProps) {
  const { control, setValue, watch } = useFormContext();

  // 1. CONSOLIDATED STATE: One state object for all dates, just like the
  // grandparent form
  const [dates, setDates] = useState({
    dam: watch("damBirthDate") ? new Date(watch("damBirthDate")) : undefined,
    sire: watch("sireBirthDate") ? new Date(watch("sireBirthDate")) : undefined,
  });

  // 2. REUSABLE HANDLER: One function to handle date selection for any parent
  const handleDateSelect = (
    dateKey: keyof typeof dates,
    fieldName: string,
    date: Date | undefined,
  ) => {
    setDates((prev) => ({ ...prev, [dateKey]: date }));
    if (date) {
      setValue(fieldName, formatDate(date));
    }
  };

  // Define props for the reusable render function
  type ParentSectionProps = {
    title: string;
    nameField: string;
    dgrField: string;
    breedField: string;
    birthDateField: string;
    imageField: string;
    imageFile: string | File | undefined;
    setImageFile: (file: string | File | undefined) => void;
    dateKey: keyof typeof dates;
    colorScheme: "pink" | "blue";
    IconComponent: ElementType;
  };

  // 3. REUSABLE RENDER FUNCTION: This is the core pattern from GrandparentalInfoForm
  const renderParentSection = ({
    title,
    nameField,
    dgrField,
    breedField,
    birthDateField,
    imageField,
    imageFile,
    setImageFile,
    dateKey,
    colorScheme,
    IconComponent,
  }: ParentSectionProps) => {
    const colorClasses = {
      pink: {
        bg: "bg-pink-50 dark:bg-pink-950/20",
        border: "border-pink-200 dark:border-pink-800",
        text: "text-pink-900 dark:text-pink-100",
        icon: "text-pink-600",
      },
      blue: {
        bg: "bg-blue-50 dark:bg-blue-950/20",
        border: "border-blue-200 dark:border-blue-800",
        text: "text-blue-900 dark:text-blue-100",
        icon: "text-blue-600",
      },
    };
    const colors = colorClasses[colorScheme];

    return (
      <div className={`${colors.bg} p-6 rounded-lg border ${colors.border}`}>
        <div className="flex items-center gap-2 mb-6">
          <IconComponent className={`h-5 w-5 ${colors.icon}`} />
          <h3 className={`text-lg font-semibold ${colors.text}`}>{title}</h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-6">
            <FormField
              control={control}
              name={nameField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Name</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter name" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={control}
              name={dgrField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>DGR</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter DGR" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={control}
              name={birthDateField}
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel className={"text-[#008c8fff]"}>
                    Date of birth
                  </FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          variant="outline"
                          className={cn(
                            "w-full pl-3 text-left font-normal",
                            !dates[dateKey] && "text-muted-foreground",
                          )}
                        >
                          <CalendarIcon className="mr-2 h-4 w-4" />
                          {dates[dateKey] ? (
                            format(dates[dateKey]!, "PPP")
                          ) : (
                            <span>Select date</span>
                          )}
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={
                          field.value ? new Date(field.value) : undefined
                        }
                        onSelect={(date) =>
                          handleDateSelect(dateKey, birthDateField, date)
                        }
                        disabled={(date: any) =>
                          date > new Date() || date < new Date("1900-01-01")
                        }
                        captionLayout="dropdown"
                      />
                    </PopoverContent>
                  </Popover>
                  <FormMessage />
                </FormItem>
              )}
            />
            {/* <FormField
							 control={ control }
							 name={ birthDateField }
							 render={ () => (
							 <FormItem className="flex flex-col">
							 <FormLabel className={"text-[#008c8fff]"}>Birth Date</FormLabel>
							 <Popover>
							 <PopoverTrigger asChild>
							 <FormControl>
							 <Button
							 variant="outline"
							 className={ cn(
							 "w-full pl-3 text-left font-normal",
							 !dates[ dateKey ] && "text-muted-foreground",
							 ) }
							 >
							 <CalendarIcon className="mr-2 h-4 w-4" />
							 { dates[ dateKey ] ? (
							 format( dates[ dateKey ]!, "PPP" )
							 ) : (
							 <span>Select date</span>
							 ) }
							 </Button>
							 </FormControl>
							 </PopoverTrigger>
							 <PopoverContent
							 className="w-auto p-0"
							 align="start"
							 side="bottom"
							 >
							 <Calendar
							 mode="single"
							 selected={ dates[ dateKey ] }
							 onSelect={ ( date ) =>
							 handleDateSelect( dateKey, birthDateField, date )
							 }
							 initialFocus
							 disabled={ ( date ) => date > new Date() }
							 />
							 </PopoverContent>
							 </Popover>
							 <FormMessage />
							 </FormItem>
							 ) }
							 /> */}
            <FormField
              control={control}
              name={breedField}
              render={({ field }) => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Breed</FormLabel>
                  <Select
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                  >
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Select breed" />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent
                      position="popper"
                      className="max-h-[300px] overflow-y-auto z-50 shadow-lg bg-white "
                    >
                      {nigerianBreeds.map((option) => (
                        <SelectItem
                          key={option.breed}
                          value={option.breed}
                          className={"overflow-y-auto z-50 background-white"}
                        >
                          {option.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div>
            <FormField
              control={control}
              name={imageField}
              render={() => (
                <FormItem>
                  <FormLabel className={"text-[#008c8fff]"}>Image</FormLabel>
                  <FormControl>
                    <ImageUpload
                      onRemove={() => setImageFile(undefined)}
                      value={imageFile}
                      onChange={setImageFile}
                      label={`Upload ${title} Image`}
                      description={`Add a photo of the ${title.toLowerCase()}`}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-2">
          <Heart className="h-6 w-6 text-pink-600" />
          <h2 className="text-2xl font-bold text-[#cfc130ff]">
            Parental Information
          </h2>
        </div>
        <p className="text-muted-foreground text-[#cfc130ff]">
          Record detailed information about the animal's parents
        </p>
      </div>
      <div className="space-y-6">
        <Tabs defaultValue="dam" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="dam" className="flex items-center gap-2">
              <Heart className="h-4 w-4" />
              Dam (Mother)
            </TabsTrigger>
            <TabsTrigger value="sire" className="flex items-center gap-2">
              <Users2 className="h-4 w-4" />
              Sire (Father)
            </TabsTrigger>
          </TabsList>

          <TabsContent value="dam" className="space-y-6 mt-6">
            {/* Call the reusable function for the Dam */}
            {renderParentSection({
              title: "Dam (Mother)",
              nameField: "damName",
              dgrField: "damDGR",
              breedField: "damBreed",
              birthDateField: "damBirthDate",
              imageField: "damImage",
              imageFile: damImageFile,
              setImageFile: setDamImageFile,
              dateKey: "dam",
              colorScheme: "pink",
              IconComponent: Heart,
            })}
          </TabsContent>

          <TabsContent value="sire" className="space-y-6 mt-6">
            {/* Call the reusable function for the Sire */}
            {renderParentSection({
              title: "Sire (Father)",
              nameField: "sireName",
              dgrField: "sireDGR",
              breedField: "sireBreed",
              birthDateField: "sireBirthDate",
              imageField: "sireImage",
              imageFile: sireImageFile,
              setImageFile: setSireImageFile,
              dateKey: "sire",
              colorScheme: "blue",
              IconComponent: Users2,
            })}
          </TabsContent>
        </Tabs>

        <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700">
          <div className="flex items-start gap-3">
            <Heart className="h-5 w-5 text-pink-600 mt-0.5 flex-shrink-0" />
            <div className="space-y-2">
              <h4 className="font-medium text-slate-900 dark:text-slate-100">
                Parental Information Guidelines
              </h4>
              <p className="text-sm text-slate-600 dark:text-slate-400">
                Parental information is crucial for tracking lineage and genetic
                traits. Use the tabs above to switch between dam and sire
                information entry.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
